// 순수 도메인 — 행동 이름별 횟수
export type ActionTally = Readonly<Record<string, number>>;

export function tally(current: ActionTally, action: string): ActionTally {
  return { ...current, [action]: (current[action] ?? 0) + 1 };
}

export function total(current: ActionTally): number {
  return Object.values(current).reduce((sum, n) => sum + n, 0);
}
